module.exports = __webpack_public_path__ + "img/gift16.bfa2fcdf.png";